import { format } from "date-fns"

import { adminApi } from "../axios"
import AdminHeaderTableCell, {
  AdminSortableHeaderCell,
  AdminTableHeadRow,
} from "../components/AdminHeaderTableCell"
import { AdminTableRow } from "../components/AdminListingTable"
import AdminRegistryListPage from "../components/AdminRegistryListPage"
import AdminTruncatedCell from "../components/AdminTruncatedCell"

export default function AdminZohoMailboxAudit() {
  return (
    <AdminRegistryListPage
      title="Zoho mailbox audit log"
      subtitle="Provisioning and sync events for Zoho mailboxes."
      fetchFn={adminApi.fetchZohoMailboxAuditLogs}
      searchLabel="Search action, mailbox, actor or error"
      noun="events"
      columnCount={6}
      tableHead={(query) => (
        <AdminTableHeadRow>
          <AdminSortableHeaderCell
            columnName="created"
            label="When"
            query={query}
            minWidth={{ xs: 72, sm: 88 }}
          />
          <AdminSortableHeaderCell
            columnName="action"
            label="Action"
            query={query}
            minWidth={{ xs: 56, sm: 72 }}
          />
          <AdminHeaderTableCell minWidth={{ xs: 88, sm: 112 }}>
            Mailbox
          </AdminHeaderTableCell>
          <AdminHeaderTableCell minWidth={{ xs: 72, sm: 96 }}>
            Actor
          </AdminHeaderTableCell>
          <AdminHeaderTableCell minWidth={{ xs: 56, sm: 64 }}>
            Success
          </AdminHeaderTableCell>
          <AdminHeaderTableCell minWidth={{ xs: 56, sm: 72 }}>
            Error
          </AdminHeaderTableCell>
        </AdminTableHeadRow>
      )}
    >
      {(rows) =>
        rows.map((log) => (
          <AdminTableRow key={log.id} hover>
            <AdminTruncatedCell
              value={
                log.created
                  ? format(new Date(log.created), "MMM d, h:mm a")
                  : "—"
              }
            />
            <AdminTruncatedCell value={log.action} />
            <AdminTruncatedCell value={log.mailbox_email} />
            <AdminTruncatedCell value={log.actor_name || log.actor_email} />
            <AdminTruncatedCell value={log.success ? "Yes" : "No"} />
            <AdminTruncatedCell value={log.error_code} />
          </AdminTableRow>
        ))
      }
    </AdminRegistryListPage>
  )
}
